import React from "react";
import "./project.css";
import workData from "../../assest/data/workData";
import link from "../../assest/link.svg";
const Project = () => {
  return (
    <div className="project_main__div">
      <p className="about_me__heading">Work</p>
      <p className="small_para_about_skill">
        Some of the noteworthy projects I have built:
      </p>
      <div className="project_display__div">
        {workData.map((item, index) => (
          <div className="project_card">
            <div className="project_left__section" key={index}>
              <img src={item.image} alt="project_1" className="project_image" />
            </div>
            <div className="project_right__section">
              <p className="project_title">{item.title}</p>
              <p className="project_description">{item.description}</p>
              <div className="project_tech__stack">
                {Object.keys(item["tech-stack"]).map((key) => {
                  return <p>{item["tech-stack"][key]}</p>;
                })}
              </div>
              <a target='_blank' rel="noreferrer" href={`${item.link}`}><img src={link} alt="link" /></a>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Project;
